import React from 'react';

const ServicesSection = props => (
  <div>
    <div className="business-services-1x">
      <div className="container">
        <div className="business-services">
          <div className="row">
            <div className="col-md-12">
              <div className="business-title-middle">
                <h2>{props.services.info.heading}</h2>
                <span className="title-border-middle" />
              </div>
            </div>

            <div className="col-md-12 service-content">
              <div className="row">
                {props.services.core_services.map(service => (
                  <div className="col-md-4" key={service.slug}>
                    <div className="single-services single-services-fp">
                      <div className="media">
                        {/* <img className="mr-3" src="images/icon/icon-1.png" alt="Placeholder" /> */}
                        <div className="media-body">
                          <a href={`/services/${service.slug}`}>{service.title}</a>
                          {/* <p>{service.desc}</p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="padding-top-large" />
  </div>
);

export default ServicesSection;



// WEBPACK FOOTER //
// ./src/components/ServicesSectionFR.js